import {
   DEALERS_CREATE_EDIT_DEALER_OPEN_MODAL,
   DEALERS_CREATE_EDIT_DEALER_CLOSE_MODAL,
   DEALERS_CREATE_DEALER_REQUEST,
   DEALERS_CREATE_DEALER_RESULT,
   DEALERS_EDIT_DEALER_REQUEST,
   DEALERS_EDIT_DEALER_RESULT,
   DEALERS_CREATE_EDIT_DEALER_SEARCH_ROLES_REQUEST,
   DEALERS_CREATE_EDIT_DEALER_SEARCH_ROLES_RESULT,
   DEALERS_CREATE_EDIT_DEALER_GET_ROLE_REQUEST,
   DEALERS_CREATE_EDIT_DEALER_GET_ROLE_RESULT,
   DEALERS_CREATE_EDIT_DEALER_GET_DEALER_REQUEST,
   DEALERS_CREATE_EDIT_DEALER_GET_DEALER_RESULT,
   DEALERS_CREATE_EDIT_DEALER_GET_CUSTOM_ROLE_REQUEST,
   DEALERS_CREATE_EDIT_DEALER_GET_CUSTOM_ROLE_RESULT,
   DEALERS_CREATE_EDIT_DEALER_GET_ROLE_MODULES_TEMPLATE_REQUEST,
   DEALERS_CREATE_EDIT_DEALER_GET_ROLE_MODULES_TEMPLATE_RESULT,
   DEALERS_CREATE_EDIT_DEALER_SEARCH_TIMEZONES_REQUEST,
   DEALERS_CREATE_EDIT_DEALER_SEARCH_TIMEZONES_RESULT,
   DEALERS_CREDENCIAL_VALIDATION_REQUEST,
   DEALERS_CREDENCIAL_VALIDATION_RESULT
} from 'Redux/actionTypes';

export const dealersCredencialValidationRequest = (data) => ({
    type:DEALERS_CREDENCIAL_VALIDATION_REQUEST,
    payload: data
})

export const dealersCredencialValidationResult = (data) => ({
    type:DEALERS_CREDENCIAL_VALIDATION_RESULT,
    payload: data
})
export const dealersGetRoleModuleTemplateRequest = (id) => ({
    type:DEALERS_CREATE_EDIT_DEALER_GET_ROLE_MODULES_TEMPLATE_REQUEST,
    payload: id
})

export const dealersGetRoleModuleTemplateResult = (result) => ({
    type:DEALERS_CREATE_EDIT_DEALER_GET_ROLE_MODULES_TEMPLATE_RESULT,
    payload: result
})

export const dealersGetCustomRoleRequest = (id) => ({
    type:DEALERS_CREATE_EDIT_DEALER_GET_CUSTOM_ROLE_REQUEST,
    payload: id
})

export const dealersGetCustomRoleResult = (result) => ({
    type:DEALERS_CREATE_EDIT_DEALER_GET_CUSTOM_ROLE_RESULT,
    payload: result
})

export const dealersCreateEditDealerOpenModal = (data) => ({
    type:DEALERS_CREATE_EDIT_DEALER_OPEN_MODAL,
    payload: data
})

export const dealersCreateEditDealerCloseModal = () => ({
    type:DEALERS_CREATE_EDIT_DEALER_CLOSE_MODAL
})

export const dealersSearchRolesRequest = (data) => ({
    type:DEALERS_CREATE_EDIT_DEALER_SEARCH_ROLES_REQUEST,
    payload: data
})

export const dealersSearchRolesResult = (result) => ({
    type:DEALERS_CREATE_EDIT_DEALER_SEARCH_ROLES_RESULT,
    payload: result
})

export const dealersCreateDealerRequest = (data) => ({
    type:DEALERS_CREATE_DEALER_REQUEST,
    payload: data
})

export const dealersCreateDealerResult = (result) => ({
    type:DEALERS_CREATE_DEALER_RESULT,
    payload: result
})

export const dealersEditDealerRequest = (data) => ({
    type:DEALERS_EDIT_DEALER_REQUEST,
    payload: data
})

export const dealersEditDealerResult = (result) => ({
    type:DEALERS_EDIT_DEALER_RESULT,
    payload: result
})

export const dealersGetRoleRequest = (id) => ({
    type:DEALERS_CREATE_EDIT_DEALER_GET_ROLE_REQUEST,
    payload: id
})

export const dealersGetRoleResult = (result) => ({
    type:DEALERS_CREATE_EDIT_DEALER_GET_ROLE_RESULT,
    payload: result
})

export const dealersGetDealerRequest = (id) => ({
    type:DEALERS_CREATE_EDIT_DEALER_GET_DEALER_REQUEST,
    payload: id
})

export const dealersGetDealerResult = (result) => ({
    type:DEALERS_CREATE_EDIT_DEALER_GET_DEALER_RESULT,
    payload: result
})

export const dealersSearchTimeZonesRequest = () => ({
    type:DEALERS_CREATE_EDIT_DEALER_SEARCH_TIMEZONES_REQUEST
})

export const dealersSearchTimeZonesResult = (result) => ({
    type:DEALERS_CREATE_EDIT_DEALER_SEARCH_TIMEZONES_RESULT,
    payload: result
})